import React, { useContext } from "react";
import "react-circular-progressbar/dist/styles.css";
import AlertContext from "../../../../../../context/AlertContext";
import AssignmentDue from "../../../../../CommonComponents/AssignmentDue";
import UpcomingEvents from "../../../../../CommonComponents/UpcomingEvents";
import CircularProgressBar from "../../../../../CommonComponents/CircularProgressBar";
import { SOAFullComponentSkeleton } from "./SOAFullComponentSkeleton";

export const SOAFullComponent = (Props) => {
  const Alert = useContext(AlertContext);

  /* navigate to home page */

  const naviageHomeFunction = (lpId, pathName) => {
    Alert.setLpId(lpId);
    localStorage.removeItem("mockLp");
    sessionStorage.removeItem("lmpid");
    sessionStorage.setItem("lpId", lpId);

    if (pathName === "dashBoard") {
      Alert.navigate("/home");
    } else {
      setTimeout(() => {
        Alert.navigate("main/dashboard/learningpath");
      }, 100);
    }
  };

  // console.log("Props:........", Props);

  if(!Props?.data?.length>0){
    return(
      <SOAFullComponentSkeleton/>
    );
  }

  return (
    <section className="SOASelfBatchAssignmentContainer">
        <>
          {" "}
          <div className="SOAAssignment-Status">
            <div className="info">
              <div>Completed</div>
              <div>Assignments</div>
            </div>
            <div className="semi-circle-wrapper">
              <CircularProgressBar percentage={Props.percentage ?? 0} />
            </div>
          </div>
          {Props.from === "assignmentdue" && (
            <AssignmentDue
              from="SelfBatch"
              dueList={Props.data}
              batchname={Alert.batchName}
              naviageHomeFunction={naviageHomeFunction}
            />
          )}
          {Props.from === "upcomingsessions" && (
            <UpcomingEvents UpcomingEvents={Props.data} />
          )}
        </>
    </section>
  );
};
